import { useEffect, useState } from "react";
import {
  getThemePreference,
  getVibe,
  setThemePreference,
  setVibe,
  subscribeThemePreference,
} from "../theme/mode";
import type { ThemePreference, VibeName } from "../theme/types";
import { USER } from "./user";

function useThemeState<T>(read: () => T): T {
  const [value, setValue] = useState<T>(read);

  useEffect(() => {
    const unsubscribe = subscribeThemePreference(() => setValue(read()));
    return () => {
      unsubscribe();
    };
  }, []);

  return value;
}

/** The Light / Dark / System preference, and a setter that persists it per account. */
function useThemePreference(): [ThemePreference, (preference: ThemePreference) => void] {
  const preference = useThemeState(getThemePreference);
  return [preference, (next) => setThemePreference(next, USER?.informations?.id)];
}

/** The softness axis, persisted the same way. */
export function useVibe(): [VibeName, (vibe: VibeName) => void] {
  const vibe = useThemeState(getVibe);
  return [vibe, (next) => setVibe(next, USER?.informations?.id)];
}

export default useThemePreference;
